import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import io from "socket.io-client";

/*COMPONENT*/
import Login from "../auth/Login";
import Register from "../auth/Register";
import Modal from "../common_modal/Modal";
import PaymentTable from "../payment/PaymentTable";
import Filter from "./Filter";
import CHART_DATE from "../viewer_chart/CHART_DATE.jsx";
import CUSTOM_CHART from "./CUSTOM_CHART";
import NOTIFICATION from "./NOTIFICATION";
import ONLINE_EDITORS from "./ONLINE_EDITORS";
import TimeseriesKAI from "../trivial_components/TimeseriesKAI";
import TimeseriesMonth from "../trivial_components/TimeseriesMonth";
import TimeseriesArrayItem from "../trivial_components/TimeseriesArrayItem";
import TimeseriesBiop from "../trivial_components/TimeseriesBiop";
import IotStatisticBrantas from "../trivial_components/iotStatisticBrantas";
import SidebarPCH from "../trivial_components/SidebarPCH";
import SidebarPDA from "../trivial_components/SidebarPDA";
import TimeseriesResume from "../trivial_components/TimeseriesResume";
import SIDE_TABLE from "./SIDE_TABLE.jsx";
import MODAL_EXPORT_MAP from "../MODAL_EXPORT_MAP.jsx";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/
import isEmpty from "../../App/validation/is-empty";
import getStatusMember from "../../App/validation/get-status-member";
import DownloadExcel from "../../App/validation/DownloadExcel";
import Downloadgeojson from "../../App/validation/download_geojson";

/*DATA*/
import dict from "../../Data/dict.json";
import st_colors from "../../Data/twenty_colors.json";
import DownloadShp from "../../App/validation/downloadShp.jsx";
import DownloadPdfDsda from "../../App/validation/DownloadPdfDsda.jsx";

/* ICON */

/*CONST*/
const SOCKET_URL_MAPID = "https://socket.mapid.io";

const domain = window.location.host;

const SIDEBAR_LAYER = () => {
  const project = useSelector((state) => state.project);
  const layer = useSelector((state) => state.layer);
  const auth = useSelector((state) => state.auth);
  const properties = useSelector((state) => state.properties);

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const [state, setState] = useState({
    fields_number: [],
    grid_number: [],
    fields_main: [],
    grid_main: [],
    chart_data: [],
    chart_name: [],
    csvData: [],
    features: [],
    sub_title: [],
    geo_layer: {},
    param_filter: [],
    color_set: {
      label_array: [],
      color_array: [],
    },
    feature_filter: [],
    modal_login: false,
    loginStatus: true,
    mode: "toolbox",
    modal_pricing: false,
    modal_invite: false,
    startDate: `${formatDate(new Date())}`,
    finishDate: `${formatDate(new Date())}`,
    layer_id: "",
    chart_status: false,
    editorUsers: [],
    isConnected: true,
    error: null,
  });

  const chartReference = useRef([]);
  const socketRef = useRef(null);

  useEffect(() => {
    socketRef.current = io.connect(SOCKET_URL_MAPID, {
      secure: true,
      reconnection: true,
      rejectUnauthorized: false,
    });

    on_start();

    return () => {
      if (socketRef.current) {
        socketRef.current.off(layer?.layer_id);
        socketRef.current.off("connect");
        socketRef.current.off("connect_error");
        socketRef.current.off("disconnect");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (auth.isAuthenticated !== undefined) {
      setState((prev) => ({ ...prev, modal_login: false }));
    }
  }, [auth.isAuthenticated]);

  useEffect(() => {
    if (auth.isRegistered !== undefined) {
      setState((prev) => ({ ...prev, loginStatus: true }));
    }
  }, [auth.isRegistered]);

  useEffect(() => {
    const prevLayerId = state.layer_id;
    const currentLayerId = layer?.layer_id;

    if (prevLayerId !== currentLayerId) {
      setState({
        fields_number: [],
        grid_number: [],
        fields_main: [],
        grid_main: [],
        chart_data: [],
        chart_name: [],
        csvData: [],
        features: [],
        sub_title: [],
        geo_layer: {},
        param_filter: [],
        color_set: {
          label_array: [],
          color_array: [],
        },
        feature_filter: [],
        modal_login: false,
        loginStatus: true,
        mode: "toolbox",
        modal_pricing: false,
        modal_invite: false,
        startDate: `${formatDate(new Date())}`,
        finishDate: `${formatDate(new Date())}`,
        layer_id: "",
        chart_status: false,
        editorUsers: [],
        isConnected: true,
        error: null,
      });

      const { _id, full_name, name, email, profile_picture } = auth.user || {};

      if (prevLayerId && socketRef.current) {
        socketRef.current.off(prevLayerId);
      }

      if (currentLayerId && socketRef.current) {
        setState((prev) => ({
          ...prev,
          editorUsers: [
            {
              topicId: currentLayerId,
              users: [
                {
                  _id: _id,
                  name: name,
                  full_name: full_name,
                  email: email,
                  profile_picture: profile_picture,
                  idLayer: currentLayerId,
                  borderColor: "#ABE890",
                },
              ],
            },
          ],
        }));

        socketRef.current.on(currentLayerId, (data) => {
          setState((prevState) => {
            const editorUsers = prevState.editorUsers || [];
            const existingTopicIndex = editorUsers.findIndex(
              (topic) => topic.topicId === currentLayerId,
            );

            if (data === null) {
              if (existingTopicIndex !== -1) {
                const updatedEditorUsers = [...editorUsers];
                updatedEditorUsers.splice(existingTopicIndex, 1);
                return { ...prevState, editorUsers: updatedEditorUsers };
              }
            } else {
              if (existingTopicIndex === -1) {
                return {
                  ...prevState,
                  editorUsers: [
                    ...editorUsers,
                    { topicId: currentLayerId, users: data },
                  ],
                };
              } else {
                const updatedEditorUsers = [...editorUsers];
                updatedEditorUsers[existingTopicIndex] = {
                  ...updatedEditorUsers[existingTopicIndex],
                  users: data,
                };
                return { ...prevState, editorUsers: updatedEditorUsers };
              }
            }

            return prevState;
          });
        });
      } else {
        setState((prev) => ({ ...prev, editorUsers: [] }));
        if (prevLayerId && socketRef.current) {
          socketRef.current.off(prevLayerId);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layer?.layer_id]);

  const on_start = () => {
    chartReference.current = [];
    const { layer_id, geo_layer_list } = layer;
    const geo_layer = geo_layer_list.find(
      (e) => e?.geo_layer?._id === layer_id,
    );

    let fields = geo_layer?.geo_layer?.fields || [];
    fields = fields.filter((item) => !item.isStyle);
    const features = geo_layer?.geo_layer?.geojson?.features || [];

    let sub_title = [];
    if (!features.length) {
      setState((prev) => ({
        ...prev,
        fields_number: [],
        grid_number: [],
        fields_main: [],
        grid_main: [],
        chart_data: [],
        chart_name: [],
        csvData: [],
        features: [],
        sub_title: [],
      }));
      return;
    }
    const type = geo_layer?.geo_layer?.type;
    let new_fields = fields.filter((field) => field.isHide === false);
    let csvData = features.map((ft) => {
      let obj = {};
      if (type === "Point") {
        let isUserExist = ft.user;
        obj["Reporter Name"] = isUserExist ? ft.user.full_name : "";
        obj["Reporter Phone Number"] = isUserExist ? ft.user.phone_number : "";
        obj["Reporter Email"] = isUserExist ? ft.user.email : "";
        obj["Latitude"] = ft.geometry.coordinates[1];
        obj["Longitude"] = ft.geometry.coordinates[0];
      }
      for (const key of new_fields) {
        obj[key.name] = ft.properties[key.key];
      }
      return obj;
    });
    new_fields = new_fields.filter((field) => field.type !== "image");
    const fields_number = new_fields.filter(
      (field) =>
        field.type === "number" ||
        field.type === "currency" ||
        field.type === "range",
    );
    const grid_number = features.map(({ properties }) => {
      let objectPerIndex = fields_number.map(({ key }) => {
        return properties && properties[key] ? Number(properties[key]) : 0;
      });
      return objectPerIndex;
    });
    const fields_main = new_fields.filter(
      (field) => field.isHighlight === true,
    );
    if (fields_main.length > 0) {
      sub_title.push(fields_main[0].name);
      sub_title.push(features[0].properties[fields_main[0].key]);
    }
    const grid_main = features.map(({ properties }) => {
      let objectPerIndex = fields_main.map(({ key }) => {
        return properties && properties[key] ? properties[key] : "";
      });
      return objectPerIndex;
    });
    let color_set = [];
    new_fields = new_fields.filter(
      (x) =>
        x.type === "selection" ||
        x.type === "date" ||
        x.array_templates.length > 0,
    );
    let array_color = [];
    let list_column = new_fields.map((f) => {
      const x = features
        .map((d) => d.properties[f.key])
        .sort()
        .filter((val, id, array) => {
          return array.indexOf(val) === id;
        });
      return x.length;
    });
    let max_fields_len = Math.max.apply(null, list_column);
    let i = 0;
    for (i = 0; i < max_fields_len; i++) {
      let index = i;
      if (i > st_colors.length - 1) {
        index = i % st_colors.length;
      }
      array_color.push(st_colors[index]);
    }
    const chart_data = new_fields.map((f) => {
      let column = features
        .map((d) => d.properties[f.key])
        .sort()
        .filter((val, id, array) => {
          return array.indexOf(val) === id;
        });
      let data = column.map((cl) => {
        let arr = features.filter((d) => d.properties[f.key] === cl);
        return arr.length;
      });
      let color = column.map((c, idx) => array_color[idx]);
      color_set.push({
        color_array: color.slice(),
        label_array: column.slice(),
        key: f.key,
      });
      return {
        key: f.key,
        name: f.name,
        data: {
          labels: column,
          datasets: [
            {
              data: data,
              backgroundColor: color,
              hoverBackgroundColor: color,
            },
          ],
        },
        type: f.type,
        field: f,
      };
    });

    setState((prev) => ({
      ...prev,
      layer_id,
      fields_number,
      grid_number,
      chart_data,
      fields_main,
      grid_main,
      csvData,
      features,
      sub_title,
      color_set,
    }));
  };

  const toggle_login = () => {
    setState((prev) => ({ ...prev, modal_login: !prev.modal_login }));
  };

  const toggle_pricing = () => {
    setState((prev) => ({ ...prev, modal_pricing: !prev.modal_pricing }));
  };

  const toggle_invite = () => {
    setState((prev) => ({ ...prev, modal_invite: !prev.modal_invite }));
  };

  const toggleLoginRegister = () => {
    setState((prev) => ({ ...prev, loginStatus: !prev.loginStatus }));
  };

  const language = localStorage?.language || auth.language;

  const { modal_login, loginStatus, modal_pricing, modal_invite, sub_title } =
    state;

  const { isAuthenticated, isRegistered } = auth;
  let { layer_id, geo_layer_list } = layer;
  const { shared_link_check, folder_kai_timeseries } = properties;

  const role = shared_link_check?.role;

  let geo_layer = geo_layer_list.find((e) => e?.geo_layer?._id === layer_id);
  geo_layer = geo_layer?.geo_layer || {};

  const timeseries_object = geo_layer?.timeseries_object || {};
  const timeseries_mode = timeseries_object?.timeseries_mode;

  let fields_date = geo_layer?.fields ? geo_layer?.fields : [];
  fields_date = fields_date.filter((f) => f.type === "date");

  let is_author = false;

  if (isAuthenticated) {
    let userCurrentStatus;
    const { user } = auth;
    const { geo_project } = project;
    const groups = geo_project?.groups || [];
    if (!isEmpty(geo_project)) {
      userCurrentStatus = getStatusMember(groups, user?._id);
    }
    is_author = !!userCurrentStatus || !!(geo_project?.user?._id === user?._id);
  }

  let data_layer;

  if (geo_layer?.type_2 === "pch") {
    data_layer = <SidebarPCH />;
  } else if (geo_layer?.type_2 === "pda") {
    data_layer = <SidebarPDA />;
  } else if (geo_layer?.type === "IoT") {
    data_layer = <IotStatisticBrantas />;
  } else if (folder_kai_timeseries?._id) {
    data_layer = <TimeseriesResume />;
  } else {
    const download_button_excel = <DownloadExcel />;
    const download_button_json = <Downloadgeojson />;
    const download_button_shp = <DownloadShp />;
    const export_map = <MODAL_EXPORT_MAP />;
    const export_data_dsda = <DownloadPdfDsda />;

    data_layer = (
      <main>
        <section className="container background_grey_light margin_bottom">
          {geo_layer?.name && (
            <div
              style={{
                overflow: "hidden",
              }}
            >
              <h1
                title={geo_layer?.name}
                className="text_big margin_bottom"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {geo_layer?.name}
              </h1>
            </div>
          )}
          <div
            className="container background_white"
            style={{ borderRadius: "5px" }}
          >
            <p
              className="text_medium margin_bottom"
              style={{ whiteSpace: "pre-wrap", lineBreak: "strict" }}
            >
              <span className="sub_color">Deskripsi:</span>
              <br />
              <span
                title={geo_layer?.description}
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {geo_layer?.description || "-"}
              </span>
            </p>
            <p
              className="text_medium"
              style={{ whiteSpace: "pre-wrap", lineBreak: "strict" }}
            >
              <span className="sub_color">Project:</span>
              <br />
              <span
                title={
                  project?.geo_project?.name
                    ? project?.geo_project?.name
                    : layer?.geo_layer?.geo_project?.name
                }
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {project?.geo_project?.name
                  ? project?.geo_project?.name
                  : layer?.geo_layer?.geo_project?.name}
              </span>
            </p>
          </div>
        </section>
        {state.isConnected ? (
          <ONLINE_EDITORS
            editorUsers={state.editorUsers[0]}
            _id={geo_layer?._id}
          />
        ) : null}
        {(is_author || role === "viewer_download" || role === "editor") && (
          <section
            className="container background_white outline_black margin_bottom"
            style={{ paddingBottom: "1rem" }}
          >
            <div className="text_bold">Unduh Data</div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: "10px",
                marginTop: "1rem",
              }}
            >
              {download_button_excel}
              {download_button_json}
              {[
                "localhost:3003",
                "dsdajakarta.mapid.io",
                "dsdajakarta-alpha.mapid.io",
                "dsdajakarta-beta.mapid.io",
              ].includes(domain) && (
                <>
                  {download_button_shp}
                  {export_data_dsda}
                  {export_map}
                </>
              )}
            </div>
          </section>
        )}
        {fields_date?.length > 0 && <CHART_DATE field_date={fields_date[0]} />}
        <Filter />
        <CUSTOM_CHART />
        {timeseries_mode === "kai" && <TimeseriesKAI />}
        {timeseries_mode === "kai_income_farebox" && <TimeseriesMonth />}
        {(timeseries_mode === "kai_komponen_pendapatan_tiket" ||
          timeseries_mode === "kai_pendapatan_non_farebox") && (
          <TimeseriesArrayItem />
        )}
        {timeseries_mode === "kai_biop" && <TimeseriesBiop />}

        <p className="text_medium">
          {sub_title.length > 0 && sub_title[0] + " : " + sub_title[1]}
        </p>
        <NOTIFICATION geo_layer={geo_layer} auth={auth} />
      </main>
    );
  }

  const modal_login_content = modal_login && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modal_login}
      onClose={toggle_login}
    >
      <div
        className="box-body"
        style={{ marginTop: "30px", marginBottom: "30px" }}
      >
        {loginStatus || isRegistered ? <Login isNav={true} /> : <Register />}
        {loginStatus || isRegistered ? (
          <div style={{ display: "block", marginTop: "30px" }}>
            <div className="button_account">
              {dict?.["Don't have an account?"]?.[language]}
            </div>
            <div className="button_register" onClick={toggleLoginRegister}>
              {dict?.["Register here"]?.[language]}
            </div>
          </div>
        ) : (
          <div style={{ display: "block", marginTop: "30px" }}>
            <div className="button_account">
              {dict?.["Aready have an account?"]?.[language]}
            </div>
            <div className="button_register" onClick={toggleLoginRegister}>
              {dict?.["Login instead"]?.[language]}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );

  const invite_content = (
    <main style={{ textAlign: "center" }}>
      <section className="text_bold" style={{ marginBottom: "50px" }}>
        {dict?.["Subscribe to MAPID to use SINI"]?.[language]}
      </section>
      <button className="button background_black" onClick={toggle_invite}>
        {dict?.["Select subscription"]?.[language]}
      </button>
    </main>
  );

  const payment_content = (
    <main>
      <main style={{ textAlign: "center" }}>
        <section className="text_bold">
          {dict?.["Subscribe to MAPID to use SINI"]?.[language]}
        </section>
      </main>
      <PaymentTable />
    </main>
  );

  const modal_pricing_content = modal_pricing && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modal_pricing}
      onClose={toggle_pricing}
    >
      <div className="box-body">
        {modal_invite ? payment_content : invite_content}
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_login_content}
      {modal_pricing_content}
      <section
        style={{
          borderSpacing: 0,
          width: "100%",
        }}
      >
        <div>
          {data_layer}
          <SIDE_TABLE />
        </div>
      </section>
    </main>
  );
};

export default SIDEBAR_LAYER;
